import * as Colors from "../../../../globalStyles/administratorColors";

export const body = {
    paddingTop: "20px",
    paddingRight: "30px"
};

export const cardHeader = {
    backgroundColor: Colors.primary,
    color: "white",
    fontWeight: "bold"
};

export const cardStyle = {
    backgroundColor: Colors.primary,
    color: "white",
    cursor: "pointer"
};
